import http from '@/utils/http';

export default {
	list: data => http({ url: '/api/admin/v1/orderCancel/list', data }),
	detail: data => http({ url: '/api/admin/v1/orderCancel/detail', data }),
	audit: data => http({ url: '/api/admin/v1/orderCancel/audit', data, tip: true }),
};
